// extracted by mini-css-extract-plugin
export default {"contactDetails":"ContactDetails_contactDetails__+pczZ","detail":"ContactDetails_detail__pd+TS"};